<template>
  <div id="reports">
    <h5 class="pf-sub-head mb-3">Reports List</h5>
    <v-layout wrap row class="mb-1">
      <v-flex sm4 class="pr-2">
        <v-autocomplete
            v-model="report.agency" 
            @keyup.enter="searchAgencies($event)"
            :items="searchedAgencies" 
            item-text="name"
            @change="applyFliters"
            item-value="id"
            label="Search by Agency"
            id="agencySearch"
            hide-no-data
            clearable
            hint="Type atleast 3 characters to search"
            class="pr-4">
            <v-icon slot="append" @click="searchAgencies($event)"> search </v-icon>
          </v-autocomplete>
      </v-flex>
      <v-flex sm4 class="pr-2">
        <v-select v-model="report.status" label="Status type" :items="[...['All'], ...PaidStatus]" @change="applyFliters"></v-select>
      </v-flex>
      <v-flex sm4 class="pr-2">
        <v-daterange
          ref="dateRange" 
          v-model="dateRange"
          :presets="presets" 
          display-format="MM/dd/yyyy"
          :max="new Date().toISOString().substr(0,10)"
          :input-props="inputProps"
          :show-reset="false"
          @menu-closed="applyFliters"
          class="dateRange">
        </v-daterange>
      </v-flex>
    </v-layout>
    <v-layout class="mb-3">
      <v-btn class="pf-btn pf-bg-teal">
        <download-excel :data="invoiceList" :fields="exportFields" :name="exportExcelName">Export to Excel</download-excel>
      </v-btn>
    </v-layout>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="invoiceList"
        :search="search"
        no-data-text="No results"
        :pagination.sync="pagination" 
        class="pf-data-table"
      >
       <template v-slot:items="props">
          <tr>
            <td>{{ props.item.agency.name }}</td>
            <td>{{ props.item.account.length }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn icon class="ma-0" @click="viewFamilyList(props.item)" small>
                      <v-icon size="22" color="grey darken-2" >visibility</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>View</span>
              </v-tooltip>
            </td>
            <td>{{ props.item.billing_month }}</td>
            <td>{{ props.item.billing_year }}</td>
            <td>{{ props.item.amount }}</td>
            <td align="center"> {{ props.item.status }}</td>
            </tr>
        </template>
      </v-data-table>
    </v-card>
    <template>
      <div class="text-xs-center">
        <v-dialog
          v-model="isViewActive"
          width="700"
        >
          <v-card>
            <v-card-title
              class="pf-bg-teal pf-pos-relative headline white--text"
            >
              View &nbsp; <small>-&nbsp; {{ selectedAgency.name }}</small>
              <v-btn class="pf-icon-top-right" icon dark @click="isViewActive = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <app-view v-if="selectedAgency.account && selectedAgency.account.length" :data="selectedAgency"></app-view>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                flat
                @click="isViewActive = false"
                class="pf-bg-pink"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<script>
/* global session config */
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { getCollection, formatDate } from '../../helpers/helpers';
import { VDaterange } from 'vuetify-daterange-picker';
import JsonExcel from 'vue-json-excel';
import appView from '../Invoices/view';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';
import moment from 'moment';
moment.tz.setDefault(config.timezone);
export default {
  name: 'Invoice Reports',
  components: {
    VuePerfectScrollbar,
    VDaterange,
    appView,
    'downloadExcel': JsonExcel
  },
  data: () => ({
    report: {
      agency: '',
      status: 'All'
    },
    config: config,
    searchedAgencies: [],
    PaidStatus: ['All', 'Not Paid', 'Paid'],
    isViewActive: false,
    selectedAgency: [],
    invoiceList: [],
    search: '',
    dateRange: { 
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    presets: [
      {
        label: 'Today',
        range: [
          moment().startOf('day').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD'),
        ],
      },
      {
        label: 'Yesterday',
        range: [
          moment().add(-1, 'days').format('YYYY-MM-DD'),
          moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'This Week',
        range: [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 7 days',
        range: [
          moment().add(-7, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last 15 days',
        range: [
          moment().add(-15, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'This Month',
        range: [
          moment().startOf('month').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last Month',
        range: [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 3 Month',
        range: [
          moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
    ],
    inputProps: {
      'prepend-icon': 'event',
      'label': 'Date Range'
    },
    headers: [
      { text: 'Name', value: 'agency_name', sortable: false, align: 'left' },
      { text: 'No of Families', sortable: false, value: '' },
      { text: 'Month', value: 'billing_month', sortable: false },
      { text: 'Year', value: 'billing_year', sortable: false },
      { text: 'Amount', value: 'amount', sortable: false },
      { text: 'Status', value: 'status', sortable: false, align: 'center', width: '160px' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    exportFields: {
      'Agency Name': {
        callback: (value) => {
          return value.agency.name;
        }
      },
      'No of Families': {
        callback: (value) => {
          return value.account.length;
        }
      },
      'Month': {
        callback: (value) => {
          return value.billing_month;
        }
      },
      'Year': {
        callback: (value) => {
          return value.billing_year;
        }
      },
      'Amount': {
        callback: (value) => {
          return value.amount;
        }
      },
      'Status': {
        callback: (value) => {
          return value.status;
        }
      }
    },
    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ]
  }),
  computed: {
    exportExcelName () {
      return 'PF_Fmilies_' + (this.report.agency ? this.searchedAgencies[this.searchedAgencies.findIndex(x => x.id === this.report.agency)].name.split(' ').join('-') + '_' : '') + (this.report.status && this.report.status !== 'All' ? this.report.status + '_' : '') + (formatDate(new Date(this.dateRange.start), 'MM-DD-YYYY') + '-to-' + formatDate(new Date(this.dateRange.end), 'MM-DD-YYYY') + '_') + moment().tz(config.timezone).format('MMDDYYYY');
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline())
    {
      // return;
      next({ path: '/login' });
    }
    else
    {
      next();
    }
  },
  watch: {

  },
  created () {
    this.applyFliters();
  },
  methods: {
    viewFamilyList (item) {
      this.isViewActive = true;
      this.selectedAgency = [];
      this.selectedAgency = item;
    },
    async searchAgencies (e) {
      this.searchedAgencies = [];
      this.unselectedAgnecies = [];
      this.searchAgencyString = e.target.value ? e.target.value : document.querySelector('input[id="agencySearch"]').value;
      if ((this.searchAgencyString.length > 2)) {
        let where = { is_admin: false };
        if (!where.$or) {
          where.$or = [{
            'name': { $regex: `.*` + this.searchAgencyString + `.*`, $options: 'i' }
          }];
        } else {
          where.$or.push({
            'name': { $regex: `.*` + this.searchAgencyString + `.*`, $options: 'i' }
          });
        }       
        let attributes = 'name';
        let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load agency list'
          };
        } else {
          if (data.length > 0) {
            this.searchedAgencies = data;
          } else {
            this.searchedAgencies = [];
          }
        }
      }
    },
    async applyFliters () {
      this.invoiceList = [];
      let maxEndDate = (new Date(this.dateRange.end)).setDate((new Date(this.dateRange.end)).getDate() + 1);
      let where = {
        'createdAt': { '$gte': this.dateRange.start, '$lt': maxEndDate }
      };

      if (this.report.agency && this.report.agency !== '') {
        where['agency'] = this.report.agency;
      }
      if (this.report.status && this.report.status !== 'All') {
        where['status'] = this.report.status;
      }
      let sort = { 'createdAt': -1 };
      let populate = [{ 'path': 'account', 'select': 'name membership' }, { 'path': 'agency', 'select': 'name' }];
      let { error, data } = await getCollection('Invoice', true, 0, populate, where, null, null, sort);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load family list'
        };
      } else {
        if (data.length > 0) {
          this.invoiceList = data;
        }
      }
    },
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    }
  }
};
</script>
<style scoped lang="css">
  .dateRange >>> .v-menu {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Reports/BillingReports.vue